export default "__VITE_ASSET__BM8dH1$F__"